import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { BaseComponent } from '~Interfaces/basecomponent';
import { AuthentificationService } from '../../services/authentification.service';
import { UtilisateurService } from '../../services/utilisateur.service';

import { Roles } from '~Tools/Roles';
import { ParametrageApplicatifService } from '../../services/parametrage-applicatif.service';

/**
 * Composant header
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent implements OnInit {
    login: string = '';
    codeFournisseur: string = '';
    estUsurpe: boolean = false;
    utilisateurUsurpe: string = '';
    utilisateurSuperviseur: string = '';
    possedeDroitUsurpation: boolean = false;
    afficherAssistance: boolean = false;
    currentCulture: string = 'fr-FR';
    afficherDeconnexion: boolean = false;

    @ViewChild('headerNav', { static: false }) headerNav: ElementRef<HTMLElement>;
    @ViewChild('burgerButton', { static: false }) burgerButton: ElementRef<HTMLElement>;

    /**
     * Constructeur
     * @param authentificationService
     * @param utilisateurService
     * @param router
     */
    constructor(
        @Inject(AuthentificationService) private authentificationService: AuthentificationService,
        @Inject(UtilisateurService) private utilisateurService: UtilisateurService,
        @Inject(ParametrageApplicatifService) private parametrageApplicatifService: ParametrageApplicatifService,
        private router: Router)
    {
        super();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        this.utilisateurService.obtenirUtilisateurCourant().subscribe((retour: any) => {
            if (retour && retour.Result) {
                this.login = retour.Result.Login;
                this.utilisateurSuperviseur = this.login;

                this.codeFournisseur = retour.Result.CodeFournisseur;

                this.estUsurpe = !!retour.Result.Superviseur;
                if (this.estUsurpe) {
                    this.utilisateurUsurpe = this.login;
                    this.utilisateurSuperviseur = retour.Result.Superviseur;
                }

                this.possedeDroitUsurpation = retour.Result.RolesGlobaux.indexOf(Roles.MRAdministrateur) >= 0 || retour.Result.RolesGlobaux.indexOf(Roles.MRInterne) >= 0;
            }
        });
        this.obtenirCulture();
    }

    obtenirCulture() {
        let culture = this.parametrageApplicatifService.obtenir('culture');
        this.currentCulture = culture;
        if (culture == "fr-FR" || culture == "nl-NL" || culture == "fr-BE" || culture == 'es-ES' || culture == 'pt-PT') {
            this.afficherAssistance = true;
        }
    }

    /**
     * D�connexion de l'utilisateur
     */
    deconnexion() {
        this.authentificationService.deconnexion().subscribe(() => {
            this.router.navigate(['login']);
        });
    }

    /**
     * Fermer le menu de navigation
     */
    fermerNav() {
        // Ferme le menu
        if (this.headerNav) {
            this.headerNav.nativeElement.classList.remove('show');
        }

        // Bouton en mode 'ferm�'
        if (this.burgerButton) {
            this.burgerButton.nativeElement.setAttribute('aria-expanded', 'false');
        }
    }
}
